module.exports = __webpack_public_path__ + "static/media/Mystery 50x150 - Dark Blue.66e55155.jpg";